import { combineReducers } from "redux";
import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { followCompany, unfollowCompany } from "../actions";

import {
  bootstrapCompanyShow,
  bootstrapCompanyAbout,
  bootstrapCompanyMembers,
  bootstrapCompanyPosts,
  bootstrapCompanyProjects,
} from "../../companies/actions";
import { bootstrapPostArticlesShow, bootstrapEmployeeInterviewsShow } from "../../post_articles/actions";

export interface CompanyFollowingsMainState {
  [key: string]: boolean;
}

export interface CompanyFollowingsState {
  followings: CompanyFollowingsMainState;
}

const companyFollowingsReducer = withImmer(reducerWithInitialState<CompanyFollowingsMainState>({}))
  .cases(
    [
      bootstrapCompanyShow,
      bootstrapCompanyAbout,
      bootstrapCompanyMembers,
      bootstrapCompanyPosts,
      bootstrapCompanyProjects,
      bootstrapPostArticlesShow,
      bootstrapEmployeeInterviewsShow,
    ],
    (state, result) => {
      const companyFollowings = result.company_followings || {};
      const followings = Object.values(companyFollowings).reduce(
        (obj, v) => {
          if (v) {
            obj[v.company_id] = true;
          }
          return obj;
        },
        {} as any
      );
      Object.assign(state, followings);
      return state;
    }
  )
  .case(followCompany.started, (state, companyId) => {
    state[companyId] = true;
    return state;
  })
  .case(followCompany.failed, (state, { params }) => {
    state[params] = false;
    return state;
  })
  .case(unfollowCompany.started, (state, companyId) => {
    state[companyId] = false;
    return state;
  })
  .case(unfollowCompany.failed, (state, { params }) => {
    state[params] = true;
    return state;
  });

export default combineReducers({
  followings: companyFollowingsReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/company_followings/reducers/index.ts